export default __webpack_public_path__ + "static/nearpod-729d9d0b2810e5fa3be9755fe44c7ae5.jpg";